<div *ngIf="includedProducts.length > 0 || optionalProducts.length > 0" [attr.data-automation-id]="'included-services-card'">
  <div class="bl-block-module bl-padding--16 bl-margin-bottom--24">
    <h2 id="membershipFeaturesHeading" class="bl-font-size--18 bl-margin-bottom--16 bl-font-weight--900">Included with your membership</h2>
    <!-- Included Shares -->
    <div class="bl-margin-top--16">
      <div
        *ngFor="let product of includedProducts; let i = index"
        class="bl-font-color--steel bl-display--flex bl-margin-top--16 bl-margin-top--16"
      >
        <div class="bl-flex--auto bl-no-body bl-padding--16 bl-bg-color--snow">
          <div class="bl-font-weight--900 bl-font-size--18">
            <div class="row bl-margin-left--0">
              <div class="bl-font-size--18 bl-display--flex bl-flex-align-middle bl-margin-bottom--16">
                <i class="cu-check-circle-solid bl-font-color--success bl-align-self--center"></i>

                <span class="bl-margin-left--8" [attr.data-automation-id]="'oao-included-product-' + product.name">
                  {{ product.name }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14">
              <span *ngIf="product.description" [innerHtml]="product.description | safe : 'html'"></span>
            </div>
            <div class="bl-padding-left--32" *ngIf="hasJointApplicants(product) && hasCoApplicant() && hasCoApplicantShares(i)">
              <div class="bl-margin-top--16 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                {{ 'oaoCheckingSavingAccounts/CoAppShares' | dictionary }}
              </div>
              <section *ngFor="let applicant of coAppProducts; let z = index">
                <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-padding-bottom--16">
                  <input
                    type="checkbox"
                    name="{{ applicant.applicantId }}-{{ applicant.shares[i].id }}-accounts-{{ z }}"
                    id="{{ applicant.applicantId }}-{{ applicant.shares[i].id }}-accounts-{{ z }}"
                    [attr.data-automation-id]="'co-app-included-products-accounts-' + z"
                    class="bl-display--inline-block"
                    [(ngModel)]="applicant.shares[i].isSelected"
                    (change)="coAppShareSelection(product, applicant, coAppProducts)"
                    [disabled]="applicant.shares[i].isDisabled && applicant.shares[i].isDisabled === true"
                  />
                  <label
                    for="{{ applicant.applicantId }}-{{ applicant.shares[i].id }}-accounts-{{ z }}"
                    class="bl-label bl-font-color--black bl-font-size--14 bl-font-weight--800"
                  >
                    {{ applicant.firstName }} {{ applicant.lastName }}
                  </label>
                </div>
              </section>
            </div>
            <div *ngIf="product.optionalServices && product.optionalServices.length > 0">
              <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                {{ 'oaoCheckingSavingAccounts/OptionalService' | dictionary }}
              </div>
              <section *ngFor="let option of product.optionalServices; let j = index">
                <div class="ecp-workflow-max-width--450 bl-margin-bottom--16 bl-padding-left--16">
                  <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450">
                    <input
                      type="checkbox"
                      [(ngModel)]="option.isSelected"
                      (change)="setOptioanalServiceSelectionForRequired(product, option)"
                      name="{{ product.name }}-accounts-{{ i }}-optional-{{ j }}"
                      id="{{ product.name }}-accounts-{{ i }}-optional-{{ j }}"
                      [attr.data-automation-id]="'primary-accounts-optional-' + i + '-' + j"
                      class="bl-display--inline-block"
                    />
                    <label
                      for="{{ product.name }}-accounts-{{ i }}-optional-{{ j }}"
                      class="bl-label bl-font-color--black bl-font-size--16 bl-font-weight--800"
                    >
                      {{ option.name }}
                    </label>
                    <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14">
                      <span *ngIf="option.description" [innerHTML]="option.description | safe : 'html'"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      showCoApplicantsForOptionalServices(product.id) &&
                      option.isSelected &&
                      option.availableForJointOwner &&
                      hasJointApplicants(product) &&
                      hasOptionalServices()
                    "
                    class="bl-margin-top--16"
                  >
                    <div class="bl-margin-top--14 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                      {{ 'oaoCheckingSavingAccounts/CoAppServices' | dictionary }}
                    </div>
                    <section *ngFor="let applicant of coAppProducts; let z = index">
                      <div
                        class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-padding-left--16 bl-padding-bottom--16"
                        *ngIf="
                          applicant.shares[i].optionalServices[j].isVisible &&
                          applicant.shares[i].optionalServices[j].availableForJointOwner
                        "
                      >
                        <input
                          type="checkbox"
                          name="{{ applicant.shares[i].id }}-{{ applicant.shares[i].optionalServices[j].name }}-services-{{ z }}"
                          id="{{ applicant.shares[i].id }}-{{ applicant.shares[i].optionalServices[j].name }}-services-{{ z }}"
                          [attr.data-automation-id]="'co-app-optional-services-' + z"
                          class="bl-display--inline-block"
                          [(ngModel)]="applicant.shares[i].optionalServices[j].isSelected"
                          [disabled]="isYouthMembership()"
                          (change)="
                            coAppServiceSelection(
                              applicant.bundlePath,
                              applicant.shares[i].bundleIndex,
                              applicant.shares[i].optionalServices[j].bundleIndex,
                              applicant.shares[i].optionalServices[j].isSelected
                            )
                          "
                        />
                        <label
                          for="{{ applicant.shares[i].id }}-{{ applicant.shares[i].optionalServices[j].name }}-services-{{ z }}"
                          class="bl-label bl-font-color--black bl-font-size--14 bl-font-weight--800"
                        >
                          {{ applicant.firstName }} {{ applicant.lastName }}
                        </label>
                      </div>
                    </section>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->
    <div class="bl-margin-top--16">
      <div
        *ngFor="let service of includedMembershipServices; let i = index"
        class="bl-font-color--steel bl-display--flex bl-margin-top--16"
      >
        <div class="bl-flex--auto bl-font-color--base bl-padding--16 bl-bg-color--snow">
          <div class="bl-font-weight--900 bl-font-size--18">
            <div class="row bl-margin-left--0">
              <div class="bl-font-size--18 bl-display--flex bl-flex-align-middle bl-margin-bottom--16">
                <i class="cu-check-circle-solid bl-font-color--success bl-align-self--center"></i>
                <span class="bl-margin-left--8">
                  {{ service.relatedProductName }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div
              *ngIf="service.description"
              class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14"
              [innerHTML]="service.description | safe : 'html'"
            ></div>
            <div class="bl-padding-left--32" *ngIf="service.availableForJointOwner && hasCoApplicant()">
              <div class="bl-margin-top--16 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                {{ 'oaoCheckingSavingAccounts/CoAppShares' | dictionary }}
              </div>
              <section *ngFor="let applicant of coAppProducts; let z = index">
                <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-padding-bottom--16">
                  <input
                    type="checkbox"
                    name="{{ applicant.membershipServices[i].relatedProductId }}-service-{{ z }}"
                    id="{{ applicant.membershipServices[i].relatedProductId }}-service-{{ z }}"
                    [attr.data-automation-id]="'co-app-related-services-' + z"
                    class="bl-display--inline-block"
                    [(ngModel)]="applicant.membershipServices[i].isSelected"
                    [disabled]="isYouthMembership()"
                    (change)="
                      coAppMembershipServiceSelection(
                        applicant.bundlePath,
                        applicant.membershipServices[i].bundleIndex,
                        applicant.membershipServices[i].isSelected
                      )
                    "
                  />
                  <label
                    for="{{ applicant.membershipServices[i].relatedProductId }}-service-{{ z }}"
                    class="bl-label bl-font-color--black bl-font-size--14 bl-font-weight--800"
                  >
                    {{ applicant.firstName }} {{ applicant.lastName }}
                  </label>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Optional shares  -->
    <div class="bl-margin-top--16">
      <div
        *ngFor="let product of optionalProducts; let i = index"
        class="bl-font-color--steel bl-display--flex bl-margin-top--16 bl-margin-top--16"
      >
        <div class="bl-flex--auto bl-no-body bl-padding--16 bl-bg-color--snow">
          <div class="bl-font-weight--900 bl-font-size--18">
            <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450">
              <input
                type="checkbox"
                [(ngModel)]="product.isSelected"
                name="{{ product.name }}-accounts-{{ i }}"
                id="{{ product.name }}-accounts-{{ i }}"
                [attr.data-automation-id]="'primary-optional-accounts-' + i"
                class="bl-display--inline-block"
                (change)="primaryShareSelection(product)"
              />
              <label for="{{ product.name }}-accounts-{{ i }}" class="bl-font-color--black bl-font-weight--800 bl-font-size--18">
                {{ product.name }}
              </label>
            </div>
          </div>
          <div>
            <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14">
              <span *ngIf="product.description" [innerHtml]="product.description | safe : 'html'"></span>
            </div>
            <div
              class="bl-padding-left--32"
              *ngIf="hasJointApplicants(product) && product.isSelected && hasCoApplicant() && hasCoApplicantOptionalShares(i)"
            >
              <div class="bl-margin-top--16 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                {{ 'oaoCheckingSavingAccounts/CoAppShares' | dictionary }}
              </div>
              <section *ngFor="let applicant of coAppOptionalProducts; let z = index">
                <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-padding-bottom--16">
                  <input
                    type="checkbox"
                    name="{{ applicant.applicantId }}-{{ applicant.shares[i].id }}-accounts-{{ z }}"
                    id="{{ applicant.applicantId }}-{{ applicant.shares[i].id }}-accounts-{{ z }}"
                    [attr.data-automation-id]="'co-app-optional-accounts-' + z"
                    class="bl-display--inline-block"
                    [(ngModel)]="applicant.shares[i].isSelected"
                    (change)="coAppShareSelection(product, applicant, coAppOptionalProducts)"
                    [disabled]="applicant.shares[i].isDisabled && applicant.shares[i].isDisabled === true"
                  />
                  <label
                    for="{{ applicant.applicantId }}-{{ applicant.shares[i].id }}-accounts-{{ z }}"
                    class="bl-label bl-font-color--black bl-font-size--14 bl-font-weight--800"
                  >
                    {{ applicant.firstName }} {{ applicant.lastName }}
                  </label>
                </div>
              </section>
            </div>
            <div *ngIf="product.optionalServices && product.optionalServices.length > 0 && product.isSelected">
              <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                {{ 'oaoCheckingSavingAccounts/OptionalService' | dictionary }}
              </div>
              <section *ngFor="let option of product.optionalServices; let j = index">
                <div class="ecp-workflow-max-width--450 bl-margin-bottom--16 bl-padding-left--16">
                  <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450">
                    <input
                      type="checkbox"
                      [(ngModel)]="option.isSelected"
                      (change)="setOptionalServiceSelection(product, option)"
                      name="{{ product.name }}-accounts-{{ i }}-optional-{{ j }}"
                      id="{{ product.name }}-accounts-{{ i }}-optional-{{ j }}"
                      [attr.data-automation-id]="'primary-optional-services-' + i + '-' + j"
                      class="bl-display--inline-block"
                    />
                    <label
                      for="{{ product.name }}-accounts-{{ i }}-optional-{{ j }}"
                      class="bl-label bl-font-color--black bl-font-size--16 bl-font-weight--800"
                    >
                      {{ option.name }}
                    </label>
                    <div class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14">
                      <span *ngIf="option.description" [innerHTML]="option.description | safe : 'html'"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      showCoApplicantsOptionalForOptionalServices(product.id) &&
                      option.isSelected &&
                      option.availableForJointOwner &&
                      hasJointApplicants(product) &&
                      hasOptionalProductsOptionalServices()
                    "
                    class="bl-margin-top--16"
                  >
                    <div class="bl-margin-top--14 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                      {{ 'oaoCheckingSavingAccounts/CoAppServices' | dictionary }}
                    </div>
                    <section *ngFor="let applicant of coAppOptionalProducts; let z = index">
                      <div
                        class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-padding-left--16 bl-padding-bottom--16"
                        *ngIf="
                          applicant.shares[i].optionalServices[j].isVisible &&
                          applicant.shares[i].optionalServices[j].availableForJointOwner
                        "
                      >
                        <input
                          type="checkbox"
                          name="{{ applicant.shares[i].id }}-{{ applicant.shares[i].optionalServices[j].name }}-services-{{ z }}"
                          id="{{ applicant.shares[i].id }}-{{ applicant.shares[i].optionalServices[j].name }}-services-{{ z }}"
                          [attr.data-automation-id]="'co-app-optional-services-' + z"
                          class="bl-display--inline-block"
                          [(ngModel)]="applicant.shares[i].optionalServices[j].isSelected"
                          [disabled]="isYouthMembership()"
                          (change)="
                            coAppServiceSelection(
                              applicant.bundlePath,
                              applicant.shares[i].bundleIndex,
                              applicant.shares[i].optionalServices[j].bundleIndex,
                              applicant.shares[i].optionalServices[j].isSelected
                            )
                          "
                        />
                        <label
                          for="{{ applicant.shares[i].id }}-{{ applicant.shares[i].optionalServices[j].name }}-services-{{ z }}"
                          class="bl-label bl-font-color--black bl-font-size--14 bl-font-weight--800"
                        >
                          {{ applicant.firstName }} {{ applicant.lastName }}
                        </label>
                      </div>
                    </section>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div *ngFor="let item of shareCertProducts">
        <ecp-oao-share-certificates-account
          (enableContinueButton)="emitEnableContinueButton($event)"
          [field]="field"
          [coApplicantProducts]="item.coAppProducts"
          [mainAccount]="item.products"
          [allProducts]="allProducts"
          [shareOptions]="shareOptions"
        >
        </ecp-oao-share-certificates-account>
      </div>
    </div>
    <!-- End Optional Shares -->
    <!-- Optional member service -->
    <div class="bl-margin-top--16">
      <div
        *ngFor="let service of optionalMembershipServices; let i = index"
        class="bl-font-color--steel bl-display--flex bl-margin-top--16"
      >
        <div class="bl-flex--auto bl-font-color--base bl-padding--16 bl-bg-color--snow">
          <div class="bl-font-weight--900 bl-font-size--18">
            <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450">
              <input
                type="checkbox"
                [(ngModel)]="service.isSelected"
                name="{{ service.relatedProductName }}-accounts-{{ i }}"
                id="{{ service.relatedProductName }}-accounts-{{ i }}"
                [attr.data-automation-id]="'primary-related-product-optional-service-' + i"
                class="bl-display--inline-block"
                (change)="updateOptionalSelection(service)"
              />
              <label
                for="{{ service.relatedProductName }}-accounts-{{ i }}"
                class="bl-font-color--black bl-font-weight--800 bl-font-size--18"
              >
                {{ service.relatedProductName }}
              </label>
            </div>
          </div>
          <div>
            <div
              *ngIf="service.description"
              class="bl-margin-top--8 bl-margin-bottom--8 bl-font-size--14"
              [innerHTML]="service.description | safe : 'html'"
            ></div>
            <div class="bl-padding-left--32" *ngIf="service.isSelected && service.availableForJointOwner && hasCoApplicant()">
              <div class="bl-margin-top--16 bl-margin-bottom--8 bl-font-weight--800 bl-font-color--steel">
                {{ 'oaoCheckingSavingAccounts/CoAppShares' | dictionary }}
              </div>
              <section *ngFor="let applicant of coAppOptionalProducts; let z = index">
                <div class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450 bl-padding-bottom--16">
                  <input
                    type="checkbox"
                    name="{{ applicant.membershipServices[i].relatedProductId }}-service-{{ z }}"
                    id="{{ applicant.membershipServices[i].relatedProductId }}-service-{{ z }}"
                    [attr.data-automation-id]="'co-app-related-product-optional-service-' + z"
                    class="bl-display--inline-block"
                    [(ngModel)]="applicant.membershipServices[i].isSelected"
                    [disabled]="isYouthMembership()"
                    (change)="
                      coAppMembershipServiceSelection(
                        applicant.bundlePath,
                        applicant.membershipServices[i].bundleIndex,
                        applicant.membershipServices[i].isSelected
                      )
                    "
                  />
                  <label
                    for="{{ applicant.membershipServices[i].relatedProductId }}-service-{{ z }}"
                    class="bl-label bl-font-color--black bl-font-size--14 bl-font-weight--800"
                  >
                    {{ applicant.firstName }} {{ applicant.lastName }}
                  </label>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Optional member service -->
  </div>
</div>
